import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import {
  Grid,
  Paper,
  Typography,
  Button,
  TextField,
  Autocomplete,
} from "@mui/material";
import axios from "../../../../api/axios";

const URL = "./claim/report/customer";

function CustomerClaimReport() {
  const [customerList, setCustomerList] = useState([]);
  const [customer, setCustomer] = useState(null);

  const [rows, setRows] = useState([]);

  const [totalRequested, setTotalRequested] = useState(0);
  const [totalPaid, setTotalPaid] = useState(0);

  const columns = [
    {
      field: "vinNo",
      headerName: "VIN",
      width: 180,
    },
    {
      field: "customerFirstName",
      headerName: "First Name",
      width: 170,
    },
    {
      field: "customerLastName",
      headerName: "Last Name",
      width: 170,
    },
    {
      field: "dealership",
      headerName: "Dealership",
      width: 220,
    },
    {
      field: "requestedClaimAmount",
      headerName: "Requested",
      width: 150,
      renderCell: (params) => `$${params.value ?? 0}`,
    },
    {
      field: "paidClaimAmount",
      headerName: "Paid",
      width: 150,
      renderCell: (params) => `$${params.value ?? 0}`,
    },
  ];

  useEffect(() => {
    loadCustomers();
  }, []);

  const loadCustomers = async () => {
    try {
      const response = await axios.post("./claim/customerData");

      setCustomerList(response.data.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarExport
          csvOptions={{
            fileName: "vehicle_warranty",
            utf8WithBom: true,
          }}
          printOptions={{
            disableToolbarButton: true,
          }}
        />
      </GridToolbarContainer>
    );
  }

  const searchReport = async () => {
    if (!customer) {
      alert("Please Select Customer");

      return;
    }

    try {
      const response = await axios.post("./claim/report/customerClaims", {
        customerFirstName: customer.customerFirstName,
        customerLastName: customer.customerLastName,
      });

      console.log(response.data);

      setRows(response.data.data || []);

      setTotalRequested(response.data.totalRequestedClaimAmount || 0);

      setTotalPaid(response.data.totalPaidClaimAmount || 0);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Box sx={{ marginTop: "100px" }}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Autocomplete
            options={customerList}
            getOptionLabel={(option) =>
              option.customerFirstName + " " + option.customerLastName
            }
            onChange={(e, value) => setCustomer(value)}
            renderInput={(params) => <TextField {...params} label="Customer" />}
          />
        </Grid>

        <Grid item xs={2}>
          <Button
            fullWidth
            variant="contained"
            sx={{ height: 55 }}
            onClick={searchReport}
          >
            Search
          </Button>
        </Grid>
      </Grid>

      <Grid container spacing={2} mt={2}>
        <Grid item xs={3}>
          <Paper sx={{ p: 2 }}>
            <Typography>Total Requested</Typography>
            <Typography variant="h6">${totalRequested.toFixed(2)}</Typography>
          </Paper>
        </Grid>

        <Grid item xs={3}>
          <Paper sx={{ p: 2 }}>
            <Typography>Total Paid</Typography>
            <Typography variant="h6">${totalPaid.toFixed(2)}</Typography>
          </Paper>
        </Grid>
      </Grid>

      <DataGrid
        rows={rows}
        columns={columns}
        pageSizeOptions={[10, 25, 50]}
         slots={{
            toolbar: CustomToolbar,
          }}
        pagination
        autoHeight
        sx={{ mt: 3 }}
      />
    </Box>
  );
}

export default CustomerClaimReport;
